// src/config/links.js
const LINKS = {
    twitter: "https://twitter.com/ErialosOfAstora",
    discord: "https://discord.gg/ZSwMGQNhhz",
    github: "https://github.com/effofxprime",
    delegate: "/stake", // your internal route
    dashboard: "https://dashboard.thesilverfox.pro",
    // …any other links you reuse…
};

export default LINKS;
